<template>
  <div class="recomment-item-foot-main">
    <div class="recommend-item-foot" :name="recommend.idx">
      <div class="recomment-item-foot-wra">
        <div v-if="(recommend.idx==public.classIdx.onePrice || recommend.idx==public.classIdx.chaozhi)">
          <div class="idxClass-body" v-first.once="index" v-for="(p,index) in recommend.pList" @click="public.gotoDetail(p,type,0,index)" >
            <div class="idxClass-body-head">
              <img :src="updatePicSrc(p.Pic)"/>
            </div>
            <div class="idxClass-body-body">
              <span>{{p.sTitle?p.sTitle:p.Title}}</span>
            </div>
            <div class="idxClass-body-foot">
              <div class="idxClass-body-foot-left">
                <span>¥{{p.Price}}</span>
              </div>
              <div class="idxClass-body-foot-right">
                <span>{{p.Quan_price |subPrice}}元券</span>
              </div>
            </div>
          </div>
          <div class="more-product" @click="gotoRecoment()">
            <span class="more-product-title">更多商品</span><span class="more-product-point">></span>
          </div>
        </div>
        <div v-else>
          <div class="recommend-item-foot-body" v-for="p in recommend.pList" @click="public.gotoDetail(p,type,0,index)" >
            <div class="recommend-item-foot-body-head">
              <img :src="updatePicSrc(p.Pic)"/>
            </div>
            <div class="recommend-item-foot-body-foot">
              <span class="recommend-item-foot-body-foot-price">¥{{p.Price|subPrice }}</span><span class="recommend-item-foot-body-foot-org"> ¥{{p.Org_Price|subPrice}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  export default{
    name:'RecommendSwiper',
    props:['recommend','type'],
    data(){
      return{

      }
    },
    components:{

    },
    filters:{
      subPrice:function(value){
        if(typeof value!='string'){
          value = value.toString();
        }
        var idx = value.indexOf(".");
        if(idx>-1){
          value = value.slice(0,idx);
        }
        return value;
      }
    },
    directives: {
      first: {
        bind: function (el, binding, vnode) {
          if(binding.value==0){
            el.style='border-left:#e4e4e4 solid 1px';
          }
        }
      }
    },
    created(){
    },
    mounted(){
      if(!(typeof this.type!='undefined' && this.type==this.headType.recommendMain)){
        document.getElementsByName(this.recommend.idx)[0].style.width="100%";
      }
      let uid = this.$route.query.uid;
      if(uid){
        this.setCookie("uid",uid,365);
      }
      let unionId = this.$route.query.unionId;
      if(unionId){
        this.setCookie("unionId",unionId,365);
      }
    },
    methods:{
      gotoRecoment(){
        let title = this.recommend.title;
        if(this.recommend.idx==23 || this.recommend.idx==27){
          title = typeof this.recommend.desc!='undefined' && this.recommend.desc!=''?this.recommend.desc:this.recommend.title;
        }
        this.jumpToView(this.headType.recommend,this.recommend.param,title);
      },
      updatePicSrc(pic){
        let src = pic.replace("http://","//").replace("https://","//");
        if(src.indexOf("taobaocdn.") > -1){
          src = src.split("taobaocdn.")[1];
          src = "//img.alicdn."+src;
        }
        if(src.indexOf("alicdn") > -1){
          src += "_300x300.jpg";
        }
        return src;
      },
      setCookie(key, value, day) {
        let date = new Date();
        date.setDate(date.getDate() + day);
        document.cookie = key + '=' + encodeURI(value) + ';expires=' + date;
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// RecommendSwiper.vue?0707cdb2